import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../../utils";
import { getTextColor } from "./colors";
import { SDKData } from "./SDKData";
import WalletData from "./WalletData";
export const InsolvencyMonitorCard = ({ data, }) => {
    const { insolvencyStats } = data;
    const { total, failed } = insolvencyStats;
    const healthy = total - failed;
    return (_jsxs(_Fragment, { children: [_jsx(WalletData, { address: data.address, balance: data.balance, network: data.network }), _jsxs("div", { className: cn("flex flex-row items-start", getTextColor(insolvencyStats.status)), children: [_jsx("div", { className: "w-34", children: "Solvent pools" }), _jsx("div", { children: `${healthy}/${total}` })] }), _jsx(SDKData, { data: data })] }));
};
